var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiscinaInterior(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 16.3477H15.1906",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5938 14.5L15.1901 14.5",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3604 18.0199V12.62C15.3604 11.7252 14.6354 11 13.7408 11C12.8462 11 12.1211 11.7252 12.1211 12.62",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1573 18.0199C10.1573 18.0199 10.1573 14.7288 10.1573 12.62C10.1573 11.7252 9.43225 11 8.53765 11C7.64304 11 6.91797 11.7252 6.91797 12.62",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2543 20.188C17.8635 20.188 17.4726 20.323 17.1746 20.593C16.8766 20.863 16.4857 20.998 16.0949 20.998M16.0954 21.0028C15.7046 21.0028 15.3137 20.8678 15.0157 20.5978C14.7177 20.3278 14.3269 20.1928 13.936 20.1928C13.5452 20.1928 13.1543 20.3278 12.8563 20.5978C12.5583 20.8678 12.1675 21.0028 11.7766 21.0028C11.3857 21.0028 10.9949 20.8678 10.6969 20.5978C10.3989 20.3278 10.008 20.1928 9.61719 20.1928",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2528 18.0171C17.862 18.0171 17.4711 18.1521 17.1731 18.4221C16.8751 18.6921 16.4843 18.8271 16.0934 18.8271M16.094 18.8319C15.7031 18.8319 15.3122 18.6969 15.0142 18.4269C14.7162 18.1569 14.3254 18.0219 13.9345 18.0219C13.5437 18.0219 13.1528 18.1569 12.8548 18.4269C12.5568 18.6969 12.166 18.8319 11.7751 18.8319C11.3843 18.8319 10.9934 18.6969 10.6954 18.4269C10.3974 18.1569 10.0066 18.0219 9.61571 18.0219C9.22485 18.0219 8.834 18.1569 8.536 18.4269C8.238 18.6969 7.84714 18.8319 7.45629 18.8319C7.06544 18.8319 6.67458 18.6969 6.37658 18.4269C6.07858 18.1569 5.68773 18.0219 5.29688 18.0219",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V8L12 4L21 8V21",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiscinaInterior);
export default __webpack_public_path__ + "static/media/Piscina Interior.02422653836e5cb32621c5cb984eee7e.svg";
export { ForwardRef as ReactComponent };